import { Navigate, useParams, useSearchParams } from "react-router-dom";

/** ‎/agent/:agentId/flights/booking (ללא id) → ‎/agent/:agentId/flights/search */
export default function AgentFlightsBookingRootRedirect() {
  const { agentId } = useParams();
  const [sp] = useSearchParams();
  const q = sp.toString();
  const base = `/agent/${encodeURIComponent(agentId)}/flights/search`;
  return <Navigate to={q ? `${base}?${q}` : base} replace />;
}
